import { Fragment } from 'react'
import {
  Avatar,
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  Typography
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Link } from 'react-router-dom'
import { useCart } from '../../context/Cart/CartContext'
import { useAuth } from '../../context/Auth/AuthContext'
import { formatter, getPrice, getQuantity } from '../../utils/auxFunc'
import './Sidecart.css'

const SideCart = () => {
  const { auth } = useAuth()
  const { cart, show, switchSideCart, getTotalAmount, removeByComponentId } =
    useCart()

  return show ? (
    <Box className="overlay" onClick={() => switchSideCart()}>
      <Container className="item-detail-sidecart">
        <Box className="item-sidecart__title">
          <Typography variant="h3">Mi Carrito</Typography>
          <IconButton
            className="btn-cerrar-sidecart"
            onClick={() => {
              switchSideCart()
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
        <Box className="item-detail-sidecart__box-detail-cart">
          {cart?.length > 0 && auth ? (
            <Grid
              container
              className="item-detail-sidecart__container"
              justifyContent="center"
            >
              {cart?.map((product) => {
                return (
                  <Box
                    key={product.idProduct}
                    className="item-detail-sidecart__product"
                  >
                    <Link
                      className="linkGridHome"
                      to={`/itemDetail/${product.idProduct}`}
                    >
                      <Grid item className="item-detail-sidecart__items">
                        <Avatar
                          variant="square"
                          sx={{ width: '65px', height: '65px' }}
                          src={product.components[0].img}
                          alt={product.name}
                          className="item-detail-sidecart_img"
                          imgProps={{ sx: { objectFit: 'contain' } }}
                        />
                        <Box className="item-detail-sidecart_name-and-price-product">
                          <Typography
                            style={{ fontFamily: 'Quicksand' }}
                            sx={{ fontWeight: 'bold' }}
                            className="item-detail-sidecart_name-product"
                          >
                            {product.name}
                          </Typography>
                          <Typography
                            style={{ fontFamily: 'Quicksand' }}
                            className="item-detail-sidecart_price"
                          >
                            Precio:{' '}
                            {formatter().format(
                              getPrice(
                                product.volumePrices,
                                product.price,
                                getQuantity(product)
                              ) * product.dolarValue
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                    </Link>
                    <Divider />
                    <Box className="item-detail-sidecart__name">
                      {product?.components?.map((component) => (
                        <Fragment key={component.idComponent}>
                          <Box
                            key={component.idComponent}
                            sx={{
                              position: 'relative',
                              paddingTop: '0.3rem',
                              paddingBottom: '0.3rem'
                            }}
                          >
                            <Typography
                              className="item-detail-sidecart_btn-delete"
                              sx={{
                                textAlign: 'right',
                                color: '#e60b13',
                                fontFamily: 'Quicksand',
                                position: 'absolute',
                                top: '0.1rem',
                                right: '0.2rem'
                              }}
                              onClick={() =>
                                removeByComponentId({
                                  idProduct: product.idProduct,
                                  idComponent: component.idComponent
                                })
                              }
                            >
                              Eliminar
                            </Typography>
                            {component.descriptionColor?.length > 0 ? (
                              <Typography>
                                Color: {component.descriptionColor}
                              </Typography>
                            ) : (
                              <Typography>
                                <br />
                              </Typography>
                            )}
                            <Box className="item-detail-sidecart__box-units-and-total">
                              <Typography>
                                Unidades: {component.quantity}
                              </Typography>
                              <Typography>
                                Subtotal:{' '}
                                {formatter().format(
                                  component.quantity *
                                    getPrice(
                                      product.volumePrices,
                                      product.price,
                                      getQuantity(product)
                                    ) *
                                    product.dolarValue
                                )}
                              </Typography>
                            </Box>
                          </Box>
                        </Fragment>
                      ))}
                    </Box>
                  </Box>
                )
              })}
            </Grid>
          ) : (
            <Grid
              container
              justifyContent="center"
              sx={{ alignSelf: 'center' }}
            >
              <Grid item className="empty-sidecart">
                <Typography variant="h2">Tu carrito está vacío!</Typography>
              </Grid>
            </Grid>
          )}
        </Box>
        <Divider />
        <Box className="total-sidecart">
          <Box className="total">
            <Typography
              style={{ fontFamily: 'Quicksand' }}
              sx={{ fontWeight: 'bold', paddingRight: '1rem' }}
            >
              Total:
            </Typography>
            <Typography style={{ fontFamily: 'Quicksand' }}>
              {formatter().format(getTotalAmount())}
            </Typography>
          </Box>
          <Grid container spacing={2} className="total-btns">
            <Grid
              item
              xs={7}
              sx={{ display: 'flex', justifyContent: 'center' }}
            >
              <Link to="/" style={{ textDecoration: 'none' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    switchSideCart()
                  }}
                  style={{ width: '170px' }}
                >
                  Seguir comprando
                </Button>
              </Link>
            </Grid>
            <Grid
              item
              xs={5}
              sx={{ display: 'flex', justifyContent: 'center' }}
            >
              <Link to="/cart" style={{ textDecoration: 'none' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    switchSideCart()
                  }}
                >
                  Ir al Carrito
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  ) : null
}

export default SideCart
